<template>
  <div class="popup-form">
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">
          Dovolali ste sa?
        </div>
      </div>
      <div class="input-block pointer" @click="setContactedResult(true)">
        áno
      </div>
      <div class="input-block pointer" @click="setContactedResult(false)">
        nie
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientFlowContactPopUp",
  props: {
    payload: Number
  },
  methods: {
    setContactedResult(result) {
      this.$store.commit("popupManagerState/setPopupSuccessResult", {client: this.payload, contactedResult: result});
      this.closePopup();
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  }
}
</script>

<style scoped>

</style>